(function () {
  var WISHLIST_KEY = 'bd_wishlist';
  var section = document.querySelector('[data-bd-wp-section]');
  if (!section) return;

  var currentHandle = section.getAttribute('data-current-handle');
  var grid = section.querySelector('[data-bd-wp-grid]');
  var viewAllLink = section.querySelector('[data-bd-wp-view-all]');
  var maxItems = parseInt(section.getAttribute('data-max-items'), 10) || 6;

  function getWishlist() {
    try {
      var saved = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (err) {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('bd:wishlist:updated'));
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function buildCard(entry, product) {
    var variant = product.variants && product.variants[0];
    var price = variant ? variant.price : product.price;
    var image = product.featured_image || (product.images && product.images[0]) || '';

    var card = document.createElement('div');
    card.className = 'bd-wp__card';
    card.setAttribute('data-bd-wp-card', entry.id);

    card.innerHTML =
      '<a href="/products/' + product.handle + '" class="bd-wp__card-media">' +
      (image
        ? '<img src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="400">'
        : '') +
      '</a>' +
      '<button type="button" class="bd-wp__card-remove" data-bd-wp-remove="' + entry.id + '" aria-label="Remove from wishlist">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.8 8.7c0 5.2-8.8 10-8.8 10s-8.8-4.8-8.8-10A5.1 5.1 0 0 1 8.4 3.5c1.4 0 2.7.6 3.6 1.7.9-1.1 2.2-1.7 3.6-1.7a5.1 5.1 0 0 1 5.2 5.2Z"/></svg>' +
      '</button>' +
      '<div class="bd-wp__card-info">' +
      '<a href="/products/' + product.handle + '" class="bd-wp__card-title">' + (product.title || '') + '</a>' +
      '<p class="bd-wp__card-price">' + formatMoney(price) + '</p>' +
      '</div>';

    return card;
  }

  function bindRemove() {
    grid.querySelectorAll('[data-bd-wp-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-bd-wp-remove');
        var current = getWishlist();
        var updated = current.filter(function (entry) {
          return String(entry.id) !== String(id);
        });
        setWishlist(updated);

        var card = btn.closest('[data-bd-wp-card]');
        if (card) card.remove();

        if (!grid.children.length) section.hidden = true;
      });
    });
  }

  function render() {
    var list = getWishlist().filter(function (entry) {
      return entry && entry.handle && entry.handle !== currentHandle;
    });
    var toShow = list.slice(0, maxItems);

    if (!toShow.length) {
      section.hidden = true;
      return;
    }

    var fetches = toShow.map(function (entry) {
      return fetch('/products/' + entry.handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      grid.innerHTML = '';
      var any = false;

      products.forEach(function (product, i) {
        if (!product) return;
        any = true;
        grid.appendChild(buildCard(toShow[i], product));
      });

      if (!any) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      if (viewAllLink) viewAllLink.hidden = false;
      bindRemove();
    });
  }

  render();

  // Stay in sync if the customer toggles a heart elsewhere on this same
  // page load (e.g. a "You may also like" row also using the shared
  // wishlist toggle) without needing a full page refresh.
  window.addEventListener('bd:wishlist:updated', render);
})();